<template>
  <div class="upWrapper">
    <div class="up">
      <div class="avatarWrapper">
        <picture class="b-img__inner"><img src="" @error="handleImageError"></picture>
      </div>
      <div class="upDetail">
        <div class="upName">
          <p>{{upName}}</p>
        </div>
        <div class="upInfo">
          <div class="upFans">
            <p>{{upFans}}</p>
          </div>
          <div class="upVideos">
            <p>{{upVideos}} 视频</p>
          </div>
        </div>
      </div>
    </div>
    <div class="follow"><van-button type="primary"  class="followBtn">+关注</van-button></div>
  </div>
</template>

<script>
export default {
  name: "UpInfo",
  props:["upName", "upFans", "upVideos"],
  methods:{
    handleImageError(event) {
      const img = event.target;
      img.src = require("@/assets/avatar/" + 'default_2.jpg'); // 使用正确的图片路径
    },
  }
}
</script>

<style scoped lang="scss">
.upWrapper{
  margin-top: 3vw;
  margin-left: 3vw;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .follow {
    margin-right: 3vw;
  }
}
.up{
  display: flex;
  align-items: center;
  .upDetail{
    display: flex;
    flex-direction: column;
    margin-left: 3vw;
    .upName{
      p{
        color: #fb7a9f;
        font-size: 3.8vmin;
      }
    }
    .upInfo{
      display: flex;
      margin-top: 0.5vw;
      p{
        color: #a0a0a0;
        font-size: 3.0vmin;
        margin-right: 2.5vw;
      }
    }
  }
}
.avatarWrapper{
  img{
    width: 8.5vw;
    border-radius: 50%;
    object-fit: cover;
  }
}
.followBtn{
  background-color: #ff9db5;
  border-color: #ff9db5;
  border-radius: 5vw;
  width: 18vw;
  height: 6vw;
  font-size: 3.2vw;
  margin-right: 3vw;
}
</style>
